var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classes,attrs:{"color":_vm.color,"elevation":"6","href":_vm.href,"disabled":_vm.disabled,"outlined":_vm.outlined},on:{"click":_vm.handleAction}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }